import { Navigate, Route, Routes } from "react-router-dom";

import { CeremoniaRoutes } from "../ceremonias/routes/CeremoniaRoutes";
import { Navbar } from "../ui";
import { EnviarRol } from "../rol/pages/EnviarRol";
import { AcolitosRoutes } from "../acolitos/Routes/AcolitosRoutes";
import { EquiposRoutes } from "../equipos/routes/EquiposRoutes";
import { Asistencias } from "../asistencias/pages/Asistencias";

export const PrivateRoutes = ({ isLogged }) => {
  if (!isLogged) {
    return <Navigate to="/login" />;
  }
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="ceremonias/*" element={<CeremoniaRoutes />} />
        <Route path="enviar-rol/*" element={<EnviarRol />} />
        <Route path="acolitos/*" element={<AcolitosRoutes />} />
        <Route path="equipos/*" element={<EquiposRoutes />} />
        <Route path="/*" element={<Navigate to="/ceremonias" />} />
        <Route path="/asistencias" element={<Asistencias />} />
      </Routes>
    </>
  );
};
